import type { Ref } from "vue";
import { ref } from "vue";
import profileService from "@/services/profile.js";
import type { OccurrenceModelValue, OccurrenceProfile } from "../types";

export const useOccurrenceProfiles = (occurrence: Ref<OccurrenceModelValue>) => {
  const occurrenceProfilesLoading = ref<boolean>(false);

  const addLeaderName = (): void => {
    if (!occurrence.value.occurrence_profiles) occurrence.value.occurrence_profiles = [];
    occurrence.value.occurrence_profiles.push({
      legal_first_name: "",
      preferred_first_name: "",
      id: "",
      last_name: "",
    });
  };

  const setInitialLeaders = async (): Promise<void> => {
    if (!occurrence.value?.occurrence_profiles || occurrence.value.occurrence_profiles.length === 0) {
      occurrence.value.occurrence_profiles = [
        {
          legal_first_name: "",
          preferred_first_name: "",
          id: "",
          last_name: "",
        },
      ];
    } else {
      occurrenceProfilesLoading.value = true;
      const profileIds = occurrence.value.occurrence_profiles.map((profile: OccurrenceProfile) => profile.profile_id);
      profileService.getProfiles({ extraParams: { profile_ids: profileIds } }).then((response) => {
        occurrence.value.occurrence_profiles = response.data.items;
        occurrenceProfilesLoading.value = false;
      });
    }
  };

  const deleteProfileLeader = (index: number): void => {
    occurrence.value?.occurrence_profiles?.splice(index, 1);
  };

  const removeEmptyLeaders = (): void => {
    occurrence.value.occurrence_profiles = occurrence.value.occurrence_profiles?.filter(
      (obj: OccurrenceProfile) => !!obj.id,
    );
  };

  return { occurrenceProfilesLoading, addLeaderName, setInitialLeaders, deleteProfileLeader, removeEmptyLeaders };
};
